export default class HeadImage {
    constructor() {
        // navigation has to be closed explicitly once opened
        this.navOpen = false;
        this.isMobile = false;
        this.accordionNavigationContainer = document.querySelector('.js-accordion-navigation-container');

        this.toggleOnScroll = () => {
            this.toggleScrollNavigationClassOnScroll(this.accordionNavigationContainer, this.navOpen);
        };

        if (this.accordionNavigationContainer) {
            this.toggleScrollNavigation(this.toggleOnScroll);
            window.addEventListener('resize', () => {
                this.toggleScrollNavigation(this.toggleOnScroll);
            });
            this.toggleScrollNavigationOnClick();
        }
        this.toggleImage();
    }

    /**
     * Add sticky class to make accordion sub navigation sticky
     */
    toggleScrollNavigation(toggleOnScroll) {
        if (window.matchMedia('(max-width: 768px)').matches) {
            document.body.classList.add('sticky-subnavigation');
            this.accordionNavigationContainer.classList.add('js-accordion-navigation-container--closed');
            this.accordionNavigationContainer.classList.remove('js-accordion-navigation-container--open');
            window.removeEventListener('scroll', toggleOnScroll);
        } else {
            let offsetTop =
                (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
            if (offsetTop <= 715) {
                document.body.classList.remove('sticky-subnavigation');
                this.accordionNavigationContainer.classList.remove('js-accordion-navigation-container--closed');
                this.accordionNavigationContainer.classList.add('js-accordion-navigation-container--open');
            } else {
                this.accordionNavigationContainer.classList.add('js-accordion-navigation-container--closed');
                this.accordionNavigationContainer.classList.remove('js-accordion-navigation-container--open');
            }
            window.addEventListener('scroll', toggleOnScroll);
        }
    }

    toggleScrollNavigationClassOnScroll(accordionNavigationContainer, navOpen) {
        const offsetTop =
            (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

        if (offsetTop > 715) {
            document.body.classList.add('sticky-subnavigation');

            if (accordionNavigationContainer && !navOpen) {
                accordionNavigationContainer.classList.add('js-accordion-navigation-container--closed');
                accordionNavigationContainer.classList.remove('js-accordion-navigation-container--open');
            } else if (accordionNavigationContainer) {
                accordionNavigationContainer.classList.add('js-accordion-navigation-container--open');
            }
        } else {
            document.body.classList.remove('sticky-subnavigation');

            if (accordionNavigationContainer) {
                accordionNavigationContainer.classList.remove('js-accordion-navigation-container--closed');
                accordionNavigationContainer.classList.add('js-accordion-navigation-container--open');
            }
        }
    }

    /**
     * Show / hide accordion sub navigation on click
     */
    toggleScrollNavigationOnClick() {
        const scrollNavigationToggle = document.querySelector('.js-accordion-navigation-toggle');
        const accordionClose = document.querySelector('.js-accordion-navigation-container__close');

        if (!scrollNavigationToggle || !accordionClose) {
            return;
        }

        scrollNavigationToggle.addEventListener('click', () => {
            this.accordionNavigationContainer.classList.toggle('js-accordion-navigation-container--closed');
            this.accordionNavigationContainer.classList.toggle('js-accordion-navigation-container--open');
            this.navOpen = true;
        });

        accordionClose.addEventListener('click', () => {
            this.accordionNavigationContainer.classList.toggle('js-accordion-navigation-container--closed');
            this.accordionNavigationContainer.classList.toggle('js-accordion-navigation-container--open');
            this.navOpen = false;
        });
    }

    /**
     * Switch mobile and desktop image
     */
    toggleImage() {
        let headImageEl = document.querySelector('.head-image');
        if (headImageEl) {
            let image = headImageEl.getAttribute('data-image');
            let mobileImage = headImageEl.getAttribute('data-mobile-image');

            if (!image) {
                return;
            }

            this.setBackgroundImage(headImageEl, image, mobileImage);

            window.addEventListener('resize', () => {
                this.setBackgroundImage(headImageEl, image, mobileImage);
            });
        }
    }

    setBackgroundImage(element, image, mobileImage) {
        if (window.matchMedia('(min-width: 576px)').matches && this.isMobile) {
            this.isMobile = false;
            element.style.backgroundImage = 'url(' + image + ')';
        } else if (!window.matchMedia('(min-width: 576px)').matches && mobileImage && !this.isMobile) {
            this.isMobile = true;
            element.style.backgroundImage = 'url(' + mobileImage + ')';
        }
    }
}
